import {useMapsLibrary} from "@vis.gl/react-google-maps";
import {useEffect, useRef, useState} from "react";
import FieldError from "@/components/FieldError";
import {useValidation} from "@/validation";

export default function PlaceAutocomplete ({ label, name, initialValue, required, description, onChange, onPlaceSelect }) {
    const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
    const inputRef = useRef(null);
    const places = useMapsLibrary("places");
    const [touched, setTouched] = useState(false);
    const {isFieldValid, invalidMessage, showErrors} = useValidation()

    useEffect(() => {
        if (!places || !inputRef.current) return;

        const options = {
            fields: ["geometry", "address_components", "formatted_address"],
            componentRestrictions: { country: "us" },
            types: ["address"],
        };

        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [places]);

    useEffect(() => {
        if (!placeAutocomplete) return;

        placeAutocomplete.addListener("place_changed", () => {
            onPlaceSelect(placeAutocomplete.getPlace());
        });

        inputRef.current.value = initialValue
    }, [placeAutocomplete]);

    const handleChange = (e) => {
        if (e.target.value.trim() === '') {
            onPlaceSelect(null);
        }
        onPlaceSelect(e.target.value)
    }

    const valid = isFieldValid(name)
    const invalidMsg = invalidMessage(name)
    const showError = touched && !valid && invalidMsg

    useEffect(() => {
        if (showErrors) {
            setTouched(true)
        }
    }, [showErrors])

    return (
        <div className="autocomplete-container">
            <fieldset className="daisy-fieldset">
                {label && <legend className="daisy-fieldset-legend text-label inline">
                    {label}{required && ' *'}
                    {description && <span className={"input-description"}> {description}</span>}
                </legend>}
                <input
                    type={'text'}
                    name={name}
                    className={`daisy-input w-full ${!showError ? 'daisy-input-neutral' : 'daisy-input-error'}`}
                    ref={inputRef}
                    onChange={handleChange}
                />
                {showError && (
                    <FieldError message={invalidMsg} />
                )}
            </fieldset>
        </div>
    );
};
